module.exports = __webpack_public_path__ + "assets/img/user-ban.80f549eb.svg";